<template>
  <svg
    width="51"
    height="51"
    viewBox="0 0 51 51"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="51" height="51" rx="10" fill="#F1F8FF" />
    <path
      d="M30.25 14.5C32.3567 14.5 33.41 14.5 34.1667 15.0056C34.4943 15.2245 34.7755 15.5057 34.9944 15.8333C35.5 16.59 35.5 17.6433 35.5 19.75V34C35.5 36.8284 35.5 38.2426 34.6213 39.1213C33.7426 40 32.3284 40 29.5 40H20.5C17.6716 40 16.2574 40 15.3787 39.1213C14.5 38.2426 14.5 36.8284 14.5 34V19.75C14.5 17.6433 14.5 16.59 15.0056 15.8333C15.2245 15.5057 15.5057 15.2245 15.8333 15.0056C16.59 14.5 17.6433 14.5 19.75 14.5"
      stroke="url(#paint0_linear_1005_5889)"
      stroke-width="2.5"
    />
    <path
      d="M20.5 14.5C20.5 12.8431 21.8431 11.5 23.5 11.5H26.5C28.1569 11.5 29.5 12.8431 29.5 14.5C29.5 16.1569 28.1569 17.5 26.5 17.5H23.5C21.8431 17.5 20.5 16.1569 20.5 14.5Z"
      stroke="url(#paint1_linear_1005_5889)"
      stroke-width="2.5"
    />
    <path
      d="M20.5 25L29.5 25"
      stroke="url(#paint2_linear_1005_5889)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <path
      d="M20.5 31L26.5 31"
      stroke="url(#paint3_linear_1005_5889)"
      stroke-width="2.5"
      stroke-linecap="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_1005_5889"
        x1="23.5205"
        y1="7.31364"
        x2="42.0182"
        y2="11.122"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_1005_5889"
        x1="24.3659"
        y1="9.80909"
        x2="31.6107"
        y2="12.5259"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_1005_5889"
        x1="24.3659"
        y1="24.7182"
        x2="25.729"
        y2="27.7851"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_1005_5889"
        x1="23.0773"
        y1="30.7182"
        x2="24.7724"
        y2="33.2608"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#4478FF" />
        <stop offset="1" stop-color="#45B2FF" />
      </linearGradient>
    </defs>
  </svg>
</template>
